import React from 'react';
import { Card, Grid, Button, Segment, Header } from 'semantic-ui-react';

import EmailInput from '../EmailInput';
import ClaimSummary from '../ClaimSummary';
import AttachmentsList from '../AttachmentsList';

const View = ({
  claim,
  loading,
  senderEmail,
  recipient,
  forward,
  paxReplyEmail,
  email,
  documents,
  onRecipientChange,
  onEmailBodyChange,
  subject,
  selectedAttachments,
  onAttachmentsSelectionChange,
  onMessageSend,
  children
}) => (
  <Segment basic loading={loading}>
    <Card.Description>
      <Grid>
        <Grid.Row>
          <Grid.Column width={5}>
            <ClaimSummary claim={claim} />
          </Grid.Column>
          <Grid.Column width={11}>
            <Grid>
              <Grid.Row columns={1}>
                <Grid.Column>
                  <EmailInput
                    senderEmail={senderEmail}
                    recipientIconName="user"
                    recipient={recipient}
                    recipientEditable={forward}
                    onRecipientChange={onRecipientChange}
                    subject={subject}
                    body={paxReplyEmail}
                    onChange={onEmailBodyChange}
                    previousEmail={email}
                  />
                </Grid.Column>
              </Grid.Row>
              <Header> Documents to attach: </Header>
              <Grid.Row columns={1}>
                <Grid.Column>
                  <AttachmentsList
                    attachments={documents}
                    selectedAttachments={selectedAttachments}
                    handleAttachmentsSelectionChange={
                      onAttachmentsSelectionChange
                    }
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Button
                    floated="right"
                    primary
                    onClick={onMessageSend.bind(this, senderEmail)}
                    content="Send"
                  />
                  {children}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Description>
  </Segment>
);

export default View;



// WEBPACK FOOTER //
// ./src/component/EmailResponder/View.js